module.exports = __webpack_public_path__ + "static/media/1017304.365b535d.jpg";